import { Instagram, MessageCircle, Music2 } from "lucide-react";
import { Link } from "react-router-dom";
import { LASERCUT } from "@/constants/testIds";

export const Footer = () => (
  <footer className="bg-ink border-t border-linecol px-6 md:px-12 lg:px-24 py-14">
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
      <div>
        <p className="font-heading text-2xl tracking-widest text-chromed">
          LASER<span className="text-brass">CUT</span>
        </p>
        <p className="text-chromed/50 text-sm mt-2 max-w-xs">
          Fabrikasi seni logam custom — gazebo, furniture, BBQ grill, hingga wall art.
        </p>
        <div className="flex gap-5 mt-4">
          <Link data-testid="footer-link-riset" to="/riset" className="text-xs uppercase tracking-[0.15em] text-chromed/50 hover:text-brass transition-colors">
            Riset Bisnis
          </Link>
          <Link data-testid="footer-link-strategi" to="/strategi" className="text-xs uppercase tracking-[0.15em] text-chromed/50 hover:text-brass transition-colors">
            Strategi Sales
          </Link>
        </div>
      </div>

      <div className="flex gap-5">
        <a
          data-testid={LASERCUT.footerSocial("instagram")}
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-chromed/60 hover:text-brass transition-colors"
        >
          <Instagram size={20} />
        </a>
        <a
          data-testid={LASERCUT.footerSocial("tiktok")}
          href="https://tiktok.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-chromed/60 hover:text-brass transition-colors"
        >
          <Music2 size={20} />
        </a>
        <a
          data-testid={LASERCUT.footerSocial("whatsapp")}
          href={`https://wa.me/${process.env.REACT_APP_WA_NUMBER}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-chromed/60 hover:text-brass transition-colors"
        >
          <MessageCircle size={20} />
        </a>
      </div>
    </div>
    <p className="text-chromed/30 text-xs mt-10">© 2026 Lasercut. Semua karya dibuat custom.</p>
  </footer>
);
